import { InputText } from 'primereact/inputtext';
import classes from './conceptListSection.module.scss';
import searchIcon from 'assets/icons/searchIconblack.svg';
import { useBulkUpdate } from '../../useBulkUpdate';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';

interface ChipInfo {
  heading: string;
  directData: {
    Concept: string;
    NDC11_list: {
      NDC11: string;
    }[];
  }[];
  indirectData: {
    Concept: string;
    NDC11_list: {
      NDC11: string;
    }[];
  }[];
}

const ConceptListSection = ({ heading, directData, indirectData }: ChipInfo) => {
  const {
    directConceptname,
    indirectConceptname,
    directfilteredData,
    indirectfilteredData,
    isDirectBulkUpdating,
    isIndirectBulkUpdating,
    isBulkUpdating,
    handleDirectSearchChange,
    handleIndirectSearchChange,
    handleDirectBulkUpdate,
    handleIndirectBulkUpdate,
    handleBulkUpdate,
  } = useBulkUpdate(directData, indirectData);

  return (
    <div className={classes.listBtnContainer}>
      <div className={classes.headingContainer}>
        <h4>{heading}</h4>
        <div className={classes.secondaryHeading}>
          <div className={classes.heading}>Direct</div>
          <div className={classes.heading}>Indirect</div>
        </div>
        <div className={classes.searchBar}>
          <div className={classes.searchContainer} style={{ borderRight: '1px solid #4D2E6D' }}>
            <span className={classes.searchIconContainer}>
              <img src={searchIcon} alt="search" />
            </span>
            <InputText
              value={directConceptname}
              className={classes.searchInp}
              onChange={handleDirectSearchChange}
              placeholder="Search..."
            />
          </div>
          <div className={classes.searchContainer}>
            <span className={classes.searchIconContainer}>
              <img src={searchIcon} alt="search" />
            </span>
            <InputText
              value={indirectConceptname}
              className={classes.searchInp}
              onChange={handleIndirectSearchChange}
              placeholder="Search..."
            />
          </div>
        </div>
      </div>

      <div className={classes.conceptListContainer}>
        <div className={classes.conceptListContainer}>
          <div className={classes.dataContainer} style={{ borderRight: '1px solid #4D2E6D' }}>
            {directfilteredData &&
              directfilteredData.map((row, idx) => {
                return (
                  <div className={classes.row} key={idx}>
                    <div className={classes.rowContent}>
                      <Accordion className={classes.bulkUpdateAccordion}>
                        <AccordionTab header={row.Concept}>
                          {row.NDC11_list.map((item, i) => {
                            return (
                              <p key={i} className={classes.accordianVal}>
                                {item.NDC11}
                              </p>
                            );
                          })}
                        </AccordionTab>
                      </Accordion>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className={classes.dataContainer}>
            {indirectfilteredData &&
              indirectfilteredData.map((row, idx) => {
                return (
                  <div className={classes.row} key={idx}>
                    <div className={classes.rowContent}>
                      <Accordion className={classes.bulkUpdateAccordion}>
                        <AccordionTab header={row.Concept}>
                          {row.NDC11_list.map((item, i) => {
                            return (
                              <p key={i} className={classes.accordianVal}>
                                {item.NDC11}
                              </p>
                            );
                          })}
                        </AccordionTab>
                      </Accordion>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {heading === 'To Do' && (
        <div className={classes.buttonContainer}>
          <div className={classes.btn} style={{ borderRight: '1px solid #4D2E6D' }}>
            {directData && directData.length > 0 ? (
              <Button
                style={{ backgroundColor: '#029999', border: 'none' }}
                onClick={handleDirectBulkUpdate}
                loading={isDirectBulkUpdating}
              >
                Bulk Update
              </Button>
            ) : (
              <div style={{ height: '2.56rem' }}></div>
            )}
          </div>
          <div className={classes.btn}>
            {indirectData && indirectData.length > 0 ? (
              <Button
                style={{ backgroundColor: '#029999', border: 'none' }}
                onClick={handleIndirectBulkUpdate}
                loading={isIndirectBulkUpdating}
              >
                Bulk Update
              </Button>
            ) : (
              <div style={{ height: '2.56rem' }}></div>
            )}
          </div>
        </div>
      )}

      {heading === 'To Do' &&
        ((directData && directData.length > 0) || (indirectData && indirectData.length > 0)) && (
          <div className={classes.updateButtonContainer}>
            <Button
              style={{
                color: '#026565',
                fontWeight: 600,
              }}
              loading={isBulkUpdating}
              onClick={handleBulkUpdate}
              outlined
            >
              Bulk Update all NDCs
            </Button>
          </div>
        )}
    </div>
  );
};
export default observer(ConceptListSection);
